// extracted by mini-css-extract-plugin
export default {"configButton":"Edit_configButton__d+CkE","buttonRow":"Edit_buttonRow__8vo1O","done":"Edit_done__b2rID","header":"Edit_header__JxNIi"};